// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"639":"77355c7a","762":"bd46f591"}[chunkId] + ".chunk.css";
};